import styles from './ServiceDetail.module.scss'
import { useRef } from 'react'
import ServiceDetailItem from './ServiceDetailItem'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  list: {
    title: string
    linkText?: string
    linkUrl?: string
    subTitle1: string
    text1: string
    subTitle2: string
    text2: string
    subTitle3: string
    text3: string
  }[]
}

const ServiceDetail: React.FC<Props> = ({ list }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.wrapper} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>提供サービス</h2>
      <div className={styles.service__list}>
        {list.map((item, index) => (
          <ServiceDetailItem key={index} item={item} index={index} />
        ))}
      </div>
    </section>
  )
}

export default ServiceDetail
